export default __webpack_public_path__ + "static/FilsonSoftMedium-Italic-84b34c8c7e69c4211040653702319089.ttf";